export const isProductionEnvironment = () => {
  // On Vercel's preview deployment,
  // VERCEL_ENV: 'preview', NODE_ENV: 'production'
  // On Vercel's production deployment,
  // VERCEL_ENV: 'production', NODE_ENV: 'production'
  return (
    process.env.NODE_ENV === "production" &&
    process.env.NEXT_PUBLIC_VERCEL_ENV === "production"
  );
};

export const isTestEnvironment = () => {
  return process.env.NODE_ENV === "test" || process.env.E2E_PG === "1";
};

export const isPreviewEnvironment = () => {
  return (
    process.env.NEXT_PUBLIC_VERCEL_ENV &&
    process.env.NEXT_PUBLIC_VERCEL_ENV === "preview"
  );
};

export const isDevelopmentEnvironment = () => {
  return process.env.NODE_ENV === "development";
};
